export default __webpack_public_path__ + "static/toni-standing-5208388f118819925edfb049e588c379.png";